import line from "../src/images/Thanshiq/line.svg"
import box1 from "../src/images/Thanshiq/box1.svg";
import box2 from "../src/images/Thanshiq/box2.svg"
import { useEffect,useState } from "react";

function JewelleryGuides (){
  const [isHovered, setIsHovered] = useState(false);
return (
//     <div>
//          <div>
//         <div className="tet-center-center " style={{textAlign:"center"}}>
//         <h1 className=" HeadLine mt-2"> Jewellery Guides</h1>
//         <p className=" jewellery me-3 " >Check out our ready made guides to make your buying process easier.</p>
//         <img src={line} alt="line" style={{width:"1200px"}} />
// </div>
// <div
//   style={{
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: "30px", 
//   }}
// >
  
//   <div style={{ position: "relative", textAlign: "center" }}>
//     <img
//       src={box1}
//       style={{
//         width: "600px",
//         padding: "10px",
//         border: "1px solid #8E1F2D",
//         borderRadius: "8px",
//         transition: "transform 0.2s"
//       }}
//       onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
//     onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//     />
//     <p
//       style={{
//         position: "absolute",
//         top: "40%",
//         left: "28%",
//         transform: "translate(-50%, -50%)",
//         color: "white",
//         fontSize: "24px",
//         fontWeight: "bold",
//         color:"#8E1F2D",
        
//         borderRadius: "5px",
//       }}
//     >
//        <div style={{ textAlign: "left", fontSize: "24px", fontWeight: "bold" }}>
//       <p className="mb-1">Find Your Ring Size</p>
//       <button
//         className="btn"
//         style={{
//           background: "#F8D7DA",
//           border: "none",
//           padding: "5px 15px",
//           marginTop: "5px",
//           cursor: "pointer",
//           fontSize: "12px",
//           display: "flex",
//           alignItems: "center",
//           transition: "all 0.3s ease",
//         }}
//         onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
//         onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//       >
//         Explore Blog
//         <span
//           style={{
//             display: "inline-block",
//             marginLeft: "5px",
//             transition: "transform 10m ease",
//             transform: isHovered ? "translateX(5px)" : "translateX(0)",
//           }}
//         >
//           →
//         </span>
//       </button>
//     </div>
//     </p>
//   </div>

  
//   <div style={{ position: "relative", textAlign: "center" }}>
//     <img
//       src={box2}
//       style={{
//         width: "600px",
//         padding: "10px",
//         border: "1px solid #8E1F2D",
//         borderRadius: "8px",
//         transition: "transform 0.2s"
//       }}
//       onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
//     onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//     />
//     <p
//       style={{
//         position: "absolute",
//         top: "40%",
//         left: "28%",
//         transform: "translate(-50%, -50%)",
//         color: "white",
//         fontSize: "24px",
//         fontWeight: "bold",
//         color:"#8E1F2D",
        
//         borderRadius: "5px",
//       }}
//     >
//        <div style={{ textAlign: "left", fontSize: "24px", fontWeight: "bold" }}>
//       <p className="mb-1 ">The Jewellery care Guides</p>
//       <button
//         className="btn"
//         style={{
//           background: "#F8D7DA",
//           border: "none",
//           padding: "5px 15px",
//           marginTop: "5px",
//           cursor: "pointer",
//           fontSize: "12px",
//           display: "flex",
//           alignItems: "center",
//           transition: "all 0.3s ease",
//         }}
//         onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
//         onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//       >
//         Explore Blog
//         <span
//           style={{
//             display: "inline-block",
//             marginLeft: "5px",
//             transition: "transform 10m ease",
//             transform: isHovered ? "translateX(5px)" : "translateX(0)",
//           }}
//         >
//           →
//         </span>
//       </button>
//     </div>
//     </p>
//   </div>
// </div>

// </div>
// </div>
<div></div>
    
)
}
export default JewelleryGuides